export default __webpack_public_path__ + "static/media/icons8-node-js.59f2e322.svg";